import axios from "axios";
import {useState, useEffect} from "react";
import Avatar from "react-avatar";
import useCookie from "../hooks/useCookie";
import { useContext } from "react";
import { ColorContext } from "../context/ColorContext";
import { EntityManagementContext } from "../context/EntityManagementContext";

function ClassRow(props) {
    const [teacherName, setTeacherName] = useState("");
    const [teacherUsername, setTeacherUsername] = useState("");
    const csrftoken = useCookie("csrftoken");

    const {
        setMode,
        setEditingID,
        openPopup,
        classes,
        teachers,
        setClasses,
        setTeachers
    } = useContext(EntityManagementContext);

    // Headers for requests
    const headers = {
        "X-CSRFToken": csrftoken,
    };

    // Get the teacher to which this class is
    // assigned
    useEffect(() => {
        getTeacher(props.teacher);
    }, [props.teacher]);

    const { blue, white } = useContext(ColorContext);

    // Get teacher details for this class
    const getTeacher = (teacherID) => {
        axios
            .get("/api/teachers/" + teacherID)
            .then((response) => {
                let teacher = response.data;
                setTeacherName(teacher.first_name + " " + teacher.last_name);
                setTeacherUsername(teacher.email);
            });
        return teacherName;
    }

    // When the user elects to edit this class, set
    // mode to "Edit", set this as the entity being
    // edited, and open the popup if the layout
    // necessitates it
    const editClass = () => {
        setMode("Edit");
        setEditingID(props.id);
        openPopup(); // If page is narrow, open popup
    }

    // When the user elects to edit this class,
    // confirm the action and then remove this class
    // from the classes state
    const deleteClass = (event) => {
        event.preventDefault();

        let deletionConfirmation = false;

        deletionConfirmation = window.confirm(
            `\nDelete ${props.name}?\nPress OK to confirm, or cancel this action.`
        );

        if (deletionConfirmation) {
            axios
                .delete(`/api/classes/${props.id}/`, { headers })
                .then(() => {
                    // Delete from teacher's list of classes
                    let mutableTeachers = teachers;
                    let teacherIdx = mutableTeachers.findIndex(teacher => teacher.id == props.teacher);
                    mutableTeachers[teacherIdx].classes = mutableTeachers[teacherIdx].classes.filter(
                        myClass => myClass != props.id
                    );
                    setTeachers(mutableTeachers);

                    // Delete this class
                    let mutableClasses = classes;
                    mutableClasses = mutableClasses.filter(myClass => myClass.classID != props.id);
                    setClasses(mutableClasses);
                })
                .catch((error) => console.error(error));
        }
    }
    
    return(
        <>
            <td>
                {props.name} {/* Name */}
            </td>
            <td>
                <Avatar name={teacherName} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                <span>{teacherName} {/* Teacher */}
                <br /><i>{teacherUsername}</i></span>
            </td>
            <td>
                {props.grade} {/* Grade level */}
            </td>
            {/* Only allow teacher to edit/delete their own classes */}
            {props.user && 
            (props.user.is_superuser || props.user.id == props.teacher) ? (
                <td> {/* Actions */}
                    <button onClick={editClass}>Edit</button> {/* Edit button */}
                    <button onClick={deleteClass}>Delete</button> {/* Delete button */}
                </td>
            ) : (<td></td>)}            
        </>
    );
}

export default ClassRow;